/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { R as RadioGroup, d as defineCustomElement$1 } from './radio-group.js';
const IonRadioGroup = RadioGroup;
const defineCustomElement = defineCustomElement$1;
export { IonRadioGroup, defineCustomElement };